import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { makeStyles, useTheme } from '@material-ui/styles';
import { Container } from '@material-ui/core';
import SpinnerComponent from '../../../components/SpinnerComponent';
import OneLineTextInputComponent from '../manualecomponents/components/OneLineTextInputComponent';
import MultilineTextInputComponent from '../manualecomponents/components/MultilineTextInputComponent';
import FileUploader from '../manualecomponents/dettaglio_procedura/FileUploader';
import ActionButton from '../../../components/ActionButton';
import ModalListaAttrezzatura from '../manuale_personalizzato/ModalListaAttrezzatura';
import ModalSelezioneAssociazione from '../manuale_personalizzato/ModalSelezioneAssociazione';
import ModalSelezioneOrario from '../manuale_personalizzato/ModalSelezioneOrario';
import ModalSelezioneLimiti from '../manuale_personalizzato/ModalSelezioneLimiti';
import {
  getGestioneOperativaAttrezzature,
  getGestioneOperativaProceduraById,
  getGestioneOperativaReparti,
  getGestioneOperativaStrumentazione,
  updateGestioneOperativaProceduraById,
} from '../../../utils/api/aggiornamentoGestioneOperativaApi';
import { getCategorieControlli } from '../../../utils/api/categorie_controlli_api';
import { isCadenzaSenzaPeriodicita } from '../../../utils/constants';
import PropTypes from 'prop-types';
import {
  getPDFForParagrafo,
  postAggiuntaPDFForParagrafo,
} from '../../../utils/api/paragrafi_api';
import { uploadProceduraImage } from '../../../utils/api/componenti_paragrafi_api';
import ControlliConformitaTable from './ControlliConformitaTable';
import ReminderModal from './ReminderModal';
import ImageList from './ImageList';
import PdfList from './PdfList';
import CustomSnackbar from '../../../components/CustomSnackbar';
import NuovaCategoriaControlloModal from '../components/NuovaCategoriaControlloModal';
import {
  createCustomCategory,
  deleteCustomCategory,
  getCustomCategoriesByConsultantId,
} from '../../../utils/api/customCategoriesApi';
import TwoActionsAlertDialog from '../../../components/TwoActionsAlertDialog';
import { reminderFromDto, reminderToDto } from './reminderUtils';
import { UNSAVED_CHANGES_LEAVE_MESSAGE } from '../../../utils/messages';
import { reportApiError, reportError } from '../../../utils/reportApiError';

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    textAlign: 'center',
    color: 'black',
    padding: theme.spacing(3, 1),
    minHeight: '100vh',
  },
  uploadWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  uploadContainer: {
    backgroundColor: '#f9f9f9',
    padding: theme.spacing(0, 2),
    borderRadius: '8px',
    boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minWidth: '470px',
    width: '100%',
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    margin: theme.spacing(2, 0),
    width: '90%',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
}));

const DettaglioProceduraEsercizio = ({ esercizioId, proceduraId }) => {
  const theme = useTheme();
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();

  const { aggiornamentiGestioneOperativaId, consulenteId } =
    location.state || {};

  const [procedura, setProcedura] = useState({
    controlliConformita: [],
  });
  const [reparti, setReparti] = useState([]);
  const [categorieControlli, setCategorieControlli] = useState([]);
  const [tipologieStrumentazioni, setTipologieStrumentazioni] = useState([]);
  const [attrezzature, setAttrezzature] = useState([]);

  const [loading, setLoading] = useState(false);

  const [newImageFile, setNewImageFile] = useState(null);
  const [imageUploadDisabled, setImageUploadDisabled] = useState(true);
  const [pdfUploadDisabled, setPdfUploadDisabled] = useState(true);
  const [newPdfFile, setNewPdfFile] = useState(null);
  const [uploadingImage, setUploadingImage] = useState(false);

  const [isOrarioModalOpen, setIsOrarioModalOpen] = useState(false);

  const [cadenzaPassata, setCadenzaPassata] = useState('GIORNALIERA');
  const [controlloSelezionato, setControlloSelezionato] = useState({});
  const [indexToUpdate, setIndexToUpdate] = useState(0);
  const [isLimitiModalOpen, setIsLimitiModalOpen] = useState(false);
  const [limitiMode, setLimitiMode] = useState('CONTROLLO_TEMPERATURE');
  const [isControlloSemplificato, setIsControlloSemplificato] = useState(false);

  const [isAssociazioneModalOpen, setIsAssociazioneModalOpen] = useState(false);
  const [associazioneMode, setAssociazioneMode] = useState('Reparti');

  const [isAttrezzatureModalOpen, setIsAttrezzatureModalOpen] = useState(false);
  const [attrezzatureToRead, setAttrezzatureToRead] = useState([]);

  const [isNuovaCategoriaModalOpen, setIsNuovaCategoriaModalOpen] =
    useState(false);

  const [isReminderModalOpen, setIsReminderModalOpen] = useState(false);
  const [selectedReminder, setSelectedReminder] = useState(null);

  /*
   * The reminder has no endpoints of its own: it is a pair of fields on the
   * controllo conformita DTO, so it rides the same GET/PUT as the rest of this
   * screen. ReminderModal's onSave/onRemove only touch local state - the
   * single write happens in the body built by prepareControlsForSave, which is
   * also how a new controllo (id null) persists a reminder set before its first
   * save, and how a removal is sent (both fields nulled).
   */

  const [edit, setEdit] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
  });
  const [categoryToDelete, setCategoryToDelete] = useState(null);
  const [twoActionsAlertDialog, setTwoActionsAlertDialog] = useState({
    open: false,
    title: '',
    message: '',
  });
  const [
    showControlWithoutEquipmentDialog,
    setShowControlWithoutEquipmentDialog,
  ] = useState(false);

  const handleOpenSnackbar = (message) => {
    setSnackbar({ open: true, message });
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ open: false, message: '' });
  };

  useEffect(() => {
    let isMounted = true; // Il componente è montato

    const fetchData = async () => {
      try {
        const responseProcedura = await getGestioneOperativaProceduraById(
          aggiornamentiGestioneOperativaId,
          proceduraId,
        );

        const [categorieStdRes, categorieCustomRes] = await Promise.all([
          getCategorieControlli(),
          getCustomCategoriesByConsultantId(consulenteId),
        ]);

        const std = categorieStdRes
          .map((c) => ({
            ...c,
            isCustom: false,
          }))
          .sort((a, b) => a.label.localeCompare(b.label));

        const custom = categorieCustomRes
          .map((c) => ({
            name: c.nome.toUpperCase().replace(/\s+/g, '_'),
            label: c.nome,
            isCustom: true,
            id: c.id,
            unitaMisura: c.unitaMisura,
            tipoControllo: c.tipoControllo,
            consulenteId: c.consulenteId,
          }))
          .sort((a, b) => a.label.localeCompare(b.label));

        const allCategorie = [...std, ...custom];

        if (isMounted) {
          const sanitizedControlli =
            responseProcedura.procedureHaccp[0].controlliConformita?.map(
              (controllo) => {
                const rawId = controllo.tipologiaStrumentazioneId;

                const normalizedId =
                  rawId === null ||
                  rawId === undefined ||
                  rawId === '0' ||
                  rawId === 0
                    ? null
                    : String(rawId);
                // The reminder lives on as the English pair below; keeping the
                // raw DTO fields around too would leave the same value in the
                // state twice, and populateTable already drops them.
                const {
                  promemoriaStileVisivo,
                  promemoriaMessaggio,
                  ...controlloFields
                } = controllo;

                return {
                  ...controlloFields,
                  tipologiaStrumentazioneId: normalizedId,
                  cadenza: controllo.cadenza ?? 'ALTRO',
                  periodica: controllo.periodico,
                  nonConformita: controllo.controlliNonConformita || [],
                  controlliNonConformitaSemplificato:
                    controllo.controlliNonConformitaSemplificato ?? null,
                  ...reminderFromDto(controllo),
                };
              },
            ) || [];

          const updatedProcedura = {
            ...responseProcedura.procedureHaccp[0],
            controlliConformita: sanitizedControlli,
          };
          setProcedura(updatedProcedura);
          setIsControlloSemplificato(responseProcedura.controlliSemplificati);
          setCategorieControlli(allCategorie);
        }

        const responseStrumentazioni = await getGestioneOperativaStrumentazione(
          aggiornamentiGestioneOperativaId,
        );
        if (isMounted) {
          setTipologieStrumentazioni(responseStrumentazioni.strumentazioni);
        }

        const responseReparti = await getGestioneOperativaReparti(
          aggiornamentiGestioneOperativaId,
        );
        if (isMounted) {
          setReparti(responseReparti.reparti);
        }

        const responseAttrezzature = await getGestioneOperativaAttrezzature(
          aggiornamentiGestioneOperativaId,
        );
        if (isMounted) {
          setAttrezzature(responseAttrezzature);
        }
      } catch (error) {
        reportApiError(error);
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    if (aggiornamentiGestioneOperativaId && proceduraId) {
      setLoading(true);
      fetchData();
    }

    return () => {
      isMounted = false; // Imposta il flag su false quando il componente viene smontato
    };
  }, [aggiornamentiGestioneOperativaId, consulenteId, proceduraId]);

  const handleCategoriaControlloChange = (event, rowIndex) => {
    const selectedValue = event.target.value;
    if (!selectedValue) return;

    const categoria = (categorieControlli || []).find(
      (cat) => cat.name === selectedValue,
    );

    setProcedura((prev) => {
      const updatedControlli = [...(prev?.controlliConformita || [])];

      // Reset comune per tutti i tipi di categoria
      const categorySpecificReset = {
        // Temperature
        temperaturaMinima: null,
        temperaturaMassima: null,
        temperaturaConsigliata: null,
        // TPM
        valoreTPMMinimo: null,
        valoreTPMMassimo: null,
        valoreTPMConsigliato: null,
        // Personalizzata - Decimale
        valoreDecimaleMinimo: null,
        valoreDecimaleMassimo: null,
        valoreDecimaleConsigliato: null,
        // Personalizzata - Intero
        valoreInteroMinimo: null,
        valoreInteroMassimo: null,
        valoreInteroConsigliato: null,
      };

      updatedControlli[rowIndex] = {
        ...updatedControlli[rowIndex],
        ...categorySpecificReset,
        categoriaControllo: selectedValue,
        categoriaPersonalizzataId: categoria.isCustom ? categoria.id : null,
        categoriaPersonalizzataNome: categoria.isCustom
          ? categoria.label
          : null,
        categoriaPersonalizzataUnitaMisura: categoria.isCustom
          ? categoria.unitaMisura
          : null,
        tipoControllo: categoria.isCustom ? categoria.tipoControllo : null,
      };

      return {
        ...prev,
        controlliConformita: updatedControlli,
      };
    });
  };

  const handleTipologiaElementoChange = (event, rowIndex) => {
    const rawValue = event.target.value; // "" oppure id
    const value = rawValue === '' ? null : String(rawValue);

    setProcedura((prev) => {
      if (!prev?.controlliConformita) return prev;

      const isStrumentazione = value != null;
      const repartoDefault = reparti
        .filter((reparto) => reparto.repartoDefault)
        .map((reparto) => reparto.id);

      const updatedRecords = prev.controlliConformita.map(
        (controllo, index) => {
          if (index === rowIndex) {
            return {
              ...controllo,
              attrezzature: [],
              reparti: isStrumentazione ? [] : repartoDefault,
              tipologiaStrumentazioneId: value,
              descrizioneOsservabile:
                value == null ? null : controllo.descrizioneOsservabile,
            };
          }
          return controllo;
        },
      );

      return { ...prev, controlliConformita: updatedRecords };
    });

    setEdit(true);
  };

  const handleElementoOsservatoChange = (value, rowIndex) => {
    setProcedura((prev) => {
      if (!prev?.controlliConformita) return prev;

      const updatedRecords = prev.controlliConformita.map(
        (controllo, index) => {
          if (index === rowIndex) {
            return { ...controllo, descrizioneOsservabile: value };
          }
          return controllo;
        },
      );

      return { ...prev, controlliConformita: updatedRecords };
    });

    setEdit(true);
  };

  const handleLimitiChange = (value, rowIndex) => {
    setProcedura((prev) => {
      if (!prev?.controlliConformita) return prev;

      const updatedControlli = prev.controlliConformita.map(
        (controllo, index) => {
          if (index === rowIndex) {
            return { ...controllo, limiti: value };
          }
          return controllo;
        },
      );

      return { ...prev, controlliConformita: updatedControlli };
    });

    setEdit(true);
  };

  const handleCadenzaChange = (event, rowIndex) => {
    const newCadenza = event.target.value;

    setProcedura((prev) => {
      if (!prev?.controlliConformita) return prev;

      const updatedControlli = prev.controlliConformita.map(
        (controllo, index) => {
          if (index === rowIndex) {
            return {
              ...controllo,
              cadenza: newCadenza,
              cadenze: [],
              periodica: newCadenza === 'ALTRO' ? false : controllo.periodica,
              bloccante: isCadenzaSenzaPeriodicita(newCadenza)
                ? false
                : controllo.bloccante,
            };
          }
          return controllo;
        },
      );
      return { ...prev, controlliConformita: updatedControlli };
    });

    setEdit(true);
  };

  const handleCheckboxChange = (rowIndex, fieldName) => {
    setProcedura((prev) => {
      if (!prev?.controlliConformita) return prev;

      const updatedControlli = prev.controlliConformita.map(
        (controllo, index) =>
          index === rowIndex
            ? { ...controllo, [fieldName]: !controllo[fieldName] }
            : controllo,
      );

      return { ...prev, controlliConformita: updatedControlli };
    });
    setEdit(true);
  };

  const deleteRow = (rowIndex) => {
    setProcedura((prev) => ({
      ...prev,
      controlliConformita: prev.controlliConformita.filter(
        (_controllo, index) => index !== rowIndex,
      ),
    }));
  };

  const handleChangeProceduraField = (event, field) => {
    const { value } = event.target;
    setProcedura((prev) => ({ ...prev, [field]: value }));
    setEdit(true);
  };

  const handleImageFileSelection = (event) => {
    const files = event?.target?.files;

    if (!files || files.length === 0) {
      return;
    }

    const imageFile = files[0];

    if (imageFile.type !== 'image/png') {
      reportError(
        'Possono essere caricate solo immagini in formato PNG.',
        'Attenzione',
      );
      return;
    }
    if (imageFile.size > 500000) {
      reportError(
        "La dimensione dell'immagine caricata è maggiore 500kB.",
        'Attenzione',
      );
      return;
    }

    setNewImageFile(imageFile);
    setImageUploadDisabled(false);
  };

  const uploadImage = (file) => {
    setUploadingImage(true);
    setImageUploadDisabled(true);

    uploadProceduraImage(file)
      .then((response) => {
        const id = response;
        confirmImageRegistration(id);
      })
      .catch((error) => {
        reportApiError(error);
      });
  };

  const confirmImageRegistration = (id) => {
    const newImageObject = {
      id: id,
      titolo: '',
      note: '',
      posizione: procedura?.immagini?.length || 0,
    };
    setProcedura((prev) => ({
      ...prev,
      immagini: [...(prev?.immagini || []), newImageObject],
    }));
    setNewImageFile(null);
    setUploadingImage(false);
    setEdit(true);
  };

  const handlePdfFileSelection = (event) => {
    const files = event?.target?.files;

    if (!files || files.length === 0) {
      return;
    }

    const pdfFile = files[0];

    if (pdfFile.type !== 'application/pdf') {
      reportError(
        'Possono essere caricati solo documenti in formato PDF.',
        'Attenzione',
      );
      return;
    }

    if (pdfFile.size > 10000000) {
      reportError(
        'La dimensione del documento caricato è maggiore di 10MB.',
        'Attenzione',
      );
      return;
    }

    setNewPdfFile(pdfFile);
    setPdfUploadDisabled(false);
  };

  const uploadPdf = () => {
    const formData = new FormData();
    formData.append('file', newPdfFile);

    setUploadingImage(true);
    setPdfUploadDisabled(true);

    postAggiuntaPDFForParagrafo(formData)
      .then((response) => {
        const pdfId = response.id;
        confirmPdfRegistration(pdfId);
      })
      .catch((error) => {
        reportApiError(error);
      });
  };

  const confirmPdfRegistration = (pdfId) => {
    const newPdfObject = {
      id: pdfId,
      note: '',
      posizione: procedura.files.length,
      titolo: newPdfFile.name,
    };

    setProcedura((prev) => ({
      ...prev,
      files: [...(prev?.files || []), newPdfObject],
    }));
    setNewPdfFile(null);
    setPdfUploadDisabled(true);
    setUploadingImage(false);
    setEdit(true);
  };

  const handlePdfView = (pdfId) => {
    if (!pdfId) {
      reportError(
        'ID PDF mancante. Non è possibile recuperare il documento.',
        'Errore',
      );
      return;
    }

    getPDFForParagrafo(pdfId)
      .then((response) => {
        if (response?.url) {
          window.open(response.url, '_blank');
        } else {
          reportError('URL PDF non disponibile.', 'Errore');
        }
      })
      .catch((error) => {
        reportApiError(error);
      });
  };

  const deleteImageAttachment = (id) => {
    setProcedura((prev) => ({
      ...prev,
      immagini: prev.immagini
        .filter((item) => item.id !== id)
        .map((item, index) => ({ ...item, posizione: index })),
    }));
  };

  const deletePdfAttachment = (id) => {
    setProcedura((prev) => ({
      ...prev,
      files: prev.files
        .filter((item) => item.id !== id)
        .map((item, index) => ({ ...item, posizione: index })),
    }));
  };

  const changeImageField = (value, index, fields) => {
    setProcedura((prev) => {
      const updatedAttachments = prev.immagini.map((item, i) =>
        i === index ? { ...item, [fields]: value } : item,
      );

      return { ...prev, immagini: updatedAttachments };
    });
  };

  const addControlloToTable = () => {
    setProcedura((prev) => {
      const repartiIds = reparti.map((reparto) => reparto.id);
      const newControllo = {
        id: null,
        categorieControlli: categorieControlli,
        tipologieElementi: tipologieStrumentazioni,
        descrizioneOsservabile: '',
        cadenza: 'ALTRO',
        tipologiaStrumentazioneId: null,
        temperaturaMinima: null,
        temperaturaMassima: null,
        temperaturaConsigliata: null,
        valoreTPMMinimo: null,
        valoreTPMMassimo: null,
        valoreTPMConsigliato: null,
        categoriaControllo: 'CONTROLLO_GENERICO',
        selectedElementoOsservato: null,
        nonConformita: [],
        controlliNonConformitaSemplificato: null,
        limiti: '',
        attrezzature: [],
        reparti: repartiIds,
        cadenzeDisponibili: [
          'GIORNALIERA',
          'SETTIMANALE',
          'MENSILE',
          'ANNUALE',
          'ALTRO',
        ],
        cadenze: [],
        altraCadenza: null,
        bloccante: false,
        periodica: false,
        reminderStyle: null,
        reminderMessage: null,
      };

      return {
        ...prev,
        controlliConformita: [
          ...(prev.controlliConformita || []),
          newControllo,
        ],
      };
    });
    setEdit(true);
  };

  const populateTable = (proceduraData) => {
    if (!proceduraData?.controlliConformita) return;

    setProcedura((prev) => ({
      ...prev,
      controlliConformita: proceduraData.controlliConformita.map(
        (controllo) => {
          const rawId = controllo.tipologiaStrumentazioneId;
          const normalizedId =
            rawId === null ||
            rawId === undefined ||
            rawId === '0' ||
            rawId === 0
              ? null
              : String(rawId);

          return {
            id: controllo.id,
            categorieControlli,
            tipologieElementi: tipologieStrumentazioni,
            descrizioneOsservabile: controllo.descrizioneOsservabile ?? '',
            cadenza:
              controllo.cadenza ?? (controllo.altraCadenza ? 'ALTRO' : 0),
            tipologiaStrumentazioneId: normalizedId,
            temperaturaMinima:
              controllo.temperaturaMinima != null
                ? parseFloat(controllo.temperaturaMinima)
                : null,
            temperaturaMassima:
              controllo.temperaturaMassima != null
                ? parseFloat(controllo.temperaturaMassima)
                : null,
            temperaturaConsigliata:
              controllo.temperaturaConsigliata != null
                ? parseFloat(controllo.temperaturaConsigliata)
                : null,
            valoreTPMMinimo:
              controllo.valoreTPMMinimo != null
                ? parseFloat(controllo.valoreTPMMinimo)
                : null,
            valoreTPMMassimo:
              controllo.valoreTPMMassimo != null
                ? parseFloat(controllo.valoreTPMMassimo)
                : null,
            valoreTPMConsigliato:
              controllo.valoreTPMConsigliato != null
                ? parseFloat(controllo.valoreTPMConsigliato)
                : null,
            valoreDecimaleMinimo:
              controllo.valoreDecimaleMinimo != null
                ? parseFloat(controllo.valoreDecimaleMinimo)
                : null,
            valoreDecimaleMassimo:
              controllo.valoreDecimaleMassimo != null
                ? parseFloat(controllo.valoreDecimaleMassimo)
                : null,
            valoreDecimaleConsigliato:
              controllo.valoreDecimaleConsigliato != null
                ? parseFloat(controllo.valoreDecimaleConsigliato)
                : null,
            valoreInteroMinimo:
              controllo.valoreInteroMinimo != null
                ? parseInt(controllo.valoreInteroMinimo)
                : null,
            valoreInteroMassimo:
              controllo.valoreInteroMassimo != null
                ? parseInt(controllo.valoreInteroMassimo)
                : null,
            valoreInteroConsigliato:
              controllo.valoreInteroConsigliato != null
                ? parseInt(controllo.valoreInteroConsigliato)
                : null,

            categoriaControllo: controllo.categoriaControllo,
            categoriaPersonalizzataId:
              controllo.categoriaPersonalizzataId ?? null,
            categoriaPersonalizzataNome:
              controllo.categoriaPersonalizzataNome ?? null,
            categoriaPersonalizzataUnitaMisura:
              controllo.categoriaPersonalizzataUnitaMisura ?? null,
            tipoControllo: controllo.tipoControllo ?? null,

            selectedElementoOsservato: controllo.categoriaOsservabile ?? '',
            nonConformita: controllo.controlliNonConformita ?? [],
            controlliNonConformitaSemplificato:
              controllo.controlliNonConformitaSemplificato ?? null,
            limiti: controllo.limiti ?? '',
            attrezzature: controllo.attrezzature ?? [],
            reparti: controllo.reparti ?? [],
            cadenzeDisponibili: [
              'GIORNALIERA',
              'SETTIMANALE',
              'MENSILE',
              'ANNUALE',
              'ALTRO',
            ],
            cadenze: controllo.cadenze ?? [],
            altraCadenza: controllo.altraCadenza ?? null,
            bloccante: controllo.bloccante ?? false,
            periodica: controllo.periodico ?? false,
            ...reminderFromDto(controllo),
          };
        },
      ),
    }));
  };

  const openLimitiModal = (controllo, index, mode) => {
    const m = controllo.categoriaPersonalizzataId
      ? controllo.tipoControllo
      : mode;

    setControlloSelezionato(controllo);
    setIndexToUpdate(index);
    setLimitiMode(m);
    setIsLimitiModalOpen(true);
  };

  const closeLimitiModal = () => setIsLimitiModalOpen(false);

  const openReminderModal = (reminderStyle, reminderMessage, index) => {
    setSelectedReminder({
      reminderStyle: reminderStyle ?? null,
      reminderMessage: reminderMessage ?? '',
    });
    setIndexToUpdate(index);
    setIsReminderModalOpen(true);
  };

  const closeReminderModal = () => setIsReminderModalOpen(false);

  const setReminderOnControllo = (reminderStyle, reminderMessage) => {
    setProcedura((prev) => {
      if (!prev?.controlliConformita) return prev;

      const updatedControlli = prev.controlliConformita.map(
        (controllo, index) =>
          index === indexToUpdate
            ? { ...controllo, reminderStyle, reminderMessage }
            : controllo,
      );

      return { ...prev, controlliConformita: updatedControlli };
    });
    setEdit(true);
    closeReminderModal();
  };

  const openNuovaCategoriaModal = () => setIsNuovaCategoriaModalOpen(true);

  const normalizeTipologiaStrumentazioneId = (value) => {
    if (value === null || value === undefined || value === '0' || value === 0) {
      return null;
    }
    return value;
  };

  const prepareControlsForSave = (controlli) =>
    controlli.map((item) => {
      const normalizedTipologiaId = normalizeTipologiaStrumentazioneId(
        item.tipologiaStrumentazioneId,
      );
      const isStrumentazione = normalizedTipologiaId !== null;
      const isCustom = !!item.categoriaPersonalizzataId;

      return {
        id: item.id,
        proceduraHaccpId: procedura.id,
        // Controls already stored with no periodic cadenza and the flag on
        // reach this screen with the checkbox disabled; drop the flag here so
        // the save is not refused.
        // TODO: the ALTRO half can go once BSS-1610's bonifica has cleaned the
        // stored controls combining cadenza ALTRO with bloccante true; the
        // unset-cadenza half stays, those rows are still produced today.
        bloccante: isCadenzaSenzaPeriodicita(item.cadenza)
          ? false
          : (item.bloccante ?? false),
        categoriaControllo: isCustom
          ? 'PERSONALIZZATO'
          : (item.categoriaControllo ?? 'CONTROLLO_GENERICO'),
        cadenza: item.cadenza ?? null,
        altraCadenza: item.cadenza === 'ALTRO' ? '' : null,
        limiti: item.limiti ?? '',
        descrizioneOsservabile: item.descrizioneOsservabile ?? '',
        tipologiaStrumentazioneId: normalizedTipologiaId,
        reparti: item.reparti ?? [],
        attrezzature: item.attrezzature ?? [],
        categoriaOsservabile: isStrumentazione ? 'STRUMENTAZIONE' : 'ALTRO',
        periodico: item.periodica ?? false,
        cadenze: item.cadenze ?? [],
        controlliNonConformita: item.nonConformita ?? [],
        controlliNonConformitaSemplificato:
          item.controlliNonConformitaSemplificato ?? null,
        temperaturaMinima:
          item.temperaturaMinima != null
            ? parseFloat(item.temperaturaMinima)
            : null,
        temperaturaMassima:
          item.temperaturaMassima != null
            ? parseFloat(item.temperaturaMassima)
            : null,
        temperaturaConsigliata:
          item.temperaturaConsigliata != null
            ? parseFloat(item.temperaturaConsigliata)
            : null,
        valoreTPMMinimo:
          item.valoreTPMMinimo != null
            ? parseFloat(item.valoreTPMMinimo)
            : null,
        valoreTPMMassimo:
          item.valoreTPMMassimo != null
            ? parseFloat(item.valoreTPMMassimo)
            : null,
        valoreTPMConsigliato:
          item.valoreTPMConsigliato != null
            ? parseFloat(item.valoreTPMConsigliato)
            : null,
        valoreDecimaleMinimo:
          item.valoreDecimaleMinimo != null
            ? parseFloat(item.valoreDecimaleMinimo)
            : null,
        valoreDecimaleMassimo:
          item.valoreDecimaleMassimo != null
            ? parseFloat(item.valoreDecimaleMassimo)
            : null,
        valoreDecimaleConsigliato:
          item.valoreDecimaleConsigliato != null
            ? parseFloat(item.valoreDecimaleConsigliato)
            : null,
        valoreInteroMinimo:
          item.valoreInteroMinimo != null
            ? parseInt(item.valoreInteroMinimo)
            : null,
        valoreInteroMassimo:
          item.valoreInteroMassimo != null
            ? parseInt(item.valoreInteroMassimo)
            : null,
        valoreInteroConsigliato:
          item.valoreInteroConsigliato != null
            ? parseInt(item.valoreInteroConsigliato)
            : null,
        categoriaPersonalizzataId: isCustom
          ? item.categoriaPersonalizzataId
          : null,
        categoriaPersonalizzataNome: isCustom
          ? (item.categoriaPersonalizzataNome ?? null)
          : null,
        categoriaPersonalizzataUnitaMisura: isCustom
          ? (item.categoriaPersonalizzataUnitaMisura ?? null)
          : null,
        tipoControllo: isCustom ? item.tipoControllo : null,
        ...reminderToDto(item.reminderStyle, item.reminderMessage),
      };
    });

  const handleCreateCategory = async (nuovaCategoria) => {
    const newLabel = nuovaCategoria.nome || '';

    const alreadyExists = categorieControlli.some(
      (category) => category.label?.toLowerCase() === newLabel.toLowerCase(),
    );

    if (alreadyExists) {
      reportError(`La categoria "${newLabel}" esiste già.`, 'Attenzione!');
      return;
    }

    const payload = {
      ...nuovaCategoria,
      cancellato: false,
      consulenteId,
    };

    try {
      await createCustomCategory(payload);

      const responseCustomCategories =
        await getCustomCategoriesByConsultantId(consulenteId);

      const std = categorieControlli.filter((c) => !c.isCustom);

      const custom = responseCustomCategories
        .map((c) => ({
          name: c.nome.toUpperCase().replace(/\s+/g, '_'),
          label: c.nome,
          isCustom: true,
          id: c.id,
          unitaMisura: c.unitaMisura,
          tipoControllo: c.tipoControllo,
          consulenteId: c.consulenteId,
        }))
        .sort((a, b) => a.label.localeCompare(b.label));

      setCategorieControlli([...std, ...custom]);
      handleOpenSnackbar('Categoria creata con successo!');
    } catch (error) {
      reportApiError(error);
    }
  };

  const handleDeleteCategory = async (category) => {
    setTwoActionsAlertDialog({
      open: true,
      title: 'Conferma eliminazione',
      message: `Sei sicuro di voler eliminare la categoria "${category.label}"?`,
    });
    setCategoryToDelete(category);
  };

  const handleCloseTwoActionsAlertDialog = () => {
    setTwoActionsAlertDialog({
      open: false,
      title: '',
      message: '',
    });
    setCategoryToDelete(null);
  };

  const handleConfirmDeleteCategory = async () => {
    if (!categoryToDelete) return;

    try {
      await deleteCustomCategory(categoryToDelete.id);

      // REFRESH solo delle custom categories
      const responseCategorieCustom =
        await getCustomCategoriesByConsultantId(consulenteId);
      const custom = responseCategorieCustom
        .map((c) => ({
          name: c.nome.toUpperCase().replace(/\s+/g, '_'),
          label: c.nome,
          isCustom: true,
          id: c.id,
          unitaMisura: c.unitaMisura,
          tipoControllo: c.tipoControllo,
          consulenteId: c.consulenteId,
        }))
        .sort((a, b) => a.label.localeCompare(b.label));

      setCategorieControlli((prev) => {
        const std = prev.filter((c) => !c.isCustom);
        return [...std, ...custom];
      });
      handleOpenSnackbar('Categoria eliminata con successo!');
    } catch (error) {
      reportApiError(error);
    } finally {
      handleCloseTwoActionsAlertDialog();
    }
  };

  const openOrarioModal = (cadenza, controllo, index) => {
    setCadenzaPassata(cadenza);

    setIsOrarioModalOpen(true);
    setControlloSelezionato(controllo);
    setIndexToUpdate(index);
  };

  const closeOrarioModal = () => setIsOrarioModalOpen(false);

  const setCadenzeToControllo = (cadenze) => {
    setProcedura((prev) => {
      if (!prev?.controlliConformita || indexToUpdate === null) return prev;

      const updatedControlli = prev.controlliConformita.map(
        (controllo, index) =>
          index === indexToUpdate
            ? { ...controllo, cadenze: cadenze }
            : controllo,
      );

      return { ...prev, controlliConformita: updatedControlli };
    });
    setIsOrarioModalOpen(false);
  };

  const validateControllo = (controllo) => {
    const isStrumentazione = controllo.tipologiaStrumentazioneId != null;
    const hasReparti = (controllo.reparti || []).length > 0;
    // Controllo su cadenza e dati orario
    if (
      controllo.cadenza !== 'ALTRO' &&
      !controllo.periodica &&
      controllo.cadenze.length === 0
    ) {
      return 'Per controlli con cadenza giornaliera, settimanale, mensile o annuale è necessario indicare almeno un orario.';
    }
    // Se NON è STRUMENTAZIONE, deve avere almeno un reparto
    if (!isStrumentazione && !hasReparti) {
      return "E' necessario associare almeno un reparto per un controllo con categoriaOsservabile diverso da STRUMENTAZIONE.";
    }
    // Se è STRUMENTAZIONE, non deve avere reparti
    if (isStrumentazione && hasReparti) {
      return 'Un controllo con categoriaOsservabile di tipo STRUMENTAZIONE non può avere reparti associati.';
    }

    // Controllo sul controllo olio friggitrice
    if (controllo.categoriaControllo === 'OLIO_FRIGGITRICE') {
      if (
        controllo.cadenza !== 'GIORNALIERA' ||
        controllo.cadenze.length !== 2
      ) {
        return 'Per il controllo olio friggitrice è necessario specificare DUE CADENZE GIORNALIERE: una mattutina e una pomeridiana.';
      }
    }

    // Controllo su temperatura
    if (
      ['CONTROLLO_TEMPERATURE', 'OLIO_FRIGGITRICE'].includes(
        controllo.categoriaControllo,
      )
    ) {
      const temperaturaMinima = parseFloat(controllo.temperaturaMinima);
      const temperaturaMassima = parseFloat(controllo.temperaturaMassima);
      const temperaturaConsigliata = parseFloat(
        controllo.temperaturaConsigliata,
      );

      if (isNaN(temperaturaMinima) || isNaN(temperaturaMassima)) {
        return 'Occorre inserire i valori minimi e massimi di temperatura prima di procedere.';
      }
      if (temperaturaMinima > temperaturaMassima) {
        return 'La temperatura minima è maggiore della temperatura massima.';
      }
      if (
        !isNaN(temperaturaConsigliata) &&
        (temperaturaConsigliata < temperaturaMinima ||
          temperaturaConsigliata > temperaturaMassima)
      ) {
        return 'Valore della temperatura standard fuori dal range impostato.';
      }
    }

    // Controllo TPM
    if (['TPM', 'OLIO_FRIGGITRICE'].includes(controllo.categoriaControllo)) {
      const TPM_Minimo = parseFloat(controllo.valoreTPMMinimo);
      const TPM_Massimo = parseFloat(controllo.valoreTPMMassimo);

      if (isNaN(TPM_Minimo) || isNaN(TPM_Massimo)) {
        return 'Occorre inserire i valori minimi e massimi del TPM prima di procedere.';
      }
      if (TPM_Minimo > TPM_Massimo) {
        return 'Il valore TPM minimo è maggiore del valore TPM massimo.';
      }
    }

    if (controllo.categoriaControllo === 'TPM') {
      const TPM_Standard = parseFloat(controllo.valoreTPMConsigliato);
      const TPM_Minimo = parseFloat(controllo.valoreTPMMinimo);
      const TPM_Massimo = parseFloat(controllo.valoreTPMMassimo);

      if (isNaN(TPM_Standard)) {
        return 'Occorre inserire il valore standard del TPM prima di procedere.';
      }
      if (TPM_Standard < TPM_Minimo || TPM_Standard > TPM_Massimo) {
        return 'Valore del TPM standard fuori dal range impostato.';
      }
    }

    // Controllo per categoria PERSONALIZZATO
    if (controllo.categoriaPersonalizzataId) {
      const { tipoControllo } = controllo;

      if (tipoControllo === 'DECIMALE' || tipoControllo === 'INTERO') {
        const prefix =
          tipoControllo === 'DECIMALE' ? 'valoreDecimale' : 'valoreIntero';
        const toNum =
          tipoControllo === 'DECIMALE'
            ? (v) =>
                v === null || v === '' || v === undefined ? NaN : parseFloat(v)
            : (v) =>
                v === null || v === '' || v === undefined
                  ? NaN
                  : parseInt(v, 10);

        const standard = toNum(controllo[`${prefix}Consigliato`]);
        const minimo = toNum(controllo[`${prefix}Minimo`]);
        const massimo = toNum(controllo[`${prefix}Massimo`]);

        if (minimo > massimo) {
          return `Il valore minimo è maggiore del valore massimo.`;
        }
        if (isNaN(standard)) {
          return `Occorre inserire il valore standard prima di procedere.`;
        }
        if (standard < minimo || standard > massimo) {
          return `Valore standard fuori dal range impostato.`;
        }
      }
    }

    return '';
  };

  const updateControlliConformita = (limiti, valoriAggiornati) => {
    setProcedura((prev) => {
      if (!prev?.controlliConformita) return prev;

      let updatedControlliConformita = prev.controlliConformita.map(
        (controllo, index) =>
          index === indexToUpdate
            ? {
                ...controllo,
                ...(isControlloSemplificato
                  ? { controlliNonConformitaSemplificato: limiti }
                  : { nonConformita: limiti }),
                ...valoriAggiornati, // Aggiungo dinamicamente i valori da aggiornare
              }
            : controllo,
      );

      return {
        ...prev,
        controlliConformita: [...updatedControlliConformita], // Forza aggiornamento stato
      };
    });

    setIsLimitiModalOpen(false);
  };

  const passLimiti = (limiti) => {
    updateControlliConformita(limiti, {});
  };

  const passLimitiTemperatura = (limiti, tempMin, tempMax, tempCons) => {
    if (tempMin == null || tempMin === '') {
      reportError(
        'Il valore della temperatura minima non è un numero.',
        'Attenzione',
      );
      return;
    }
    if (tempMax == null || tempMax === '') {
      reportError(
        'Il valore della temperatura massima non è un numero.',
        'Attenzione',
      );
      return;
    }
    if (tempCons == null || tempCons === '') {
      reportError(
        'Il valore della temperatura consigliata non è un numero.',
        'Attenzione',
      );
      return;
    }

    updateControlliConformita(limiti, {
      temperaturaMinima: tempMin,
      temperaturaMassima: tempMax,
      temperaturaConsigliata: tempCons,
    });
  };

  const passLimitiTPM = (limiti, TPMMin, TPMMax, TPMStd) => {
    if (TPMMin == null || TPMMin === '') {
      reportError('Il valore TPM minimo non è un numero.', 'Attenzione');
      return;
    }
    if (TPMMax == null || TPMMax === '') {
      reportError('Il valore TPM massimo non è un numero.', 'Attenzione');
      return;
    }
    if (TPMStd == null || TPMStd === '') {
      reportError('Il valore TPM standard non è un numero.', 'Attenzione');
      return;
    }

    updateControlliConformita(limiti, {
      valoreTPMMinimo: TPMMin,
      valoreTPMMassimo: TPMMax,
      valoreTPMConsigliato: TPMStd,
    });
  };

  const passLimitiOlioFriggitrice = (
    limiti,
    TPMMin,
    TPMMax,
    tempMin,
    tempMax,
    tempCons,
  ) => {
    if (TPMMin == null || TPMMin === '' || TPMMax == null || TPMMax === '') {
      reportError(
        `Il valore TPM ${!TPMMin ? 'minimo' : 'massimo'} non è un numero.`,
        'Attenzione',
      );
      return;
    }
    if (
      tempMin == null ||
      tempMin === '' ||
      tempMax == null ||
      tempMax === '' ||
      tempCons == null ||
      tempCons === ''
    ) {
      reportError(
        `Il valore della temperatura ${
          !tempMin ? 'minima' : !tempMax ? 'massima' : 'standard'
        } non è un numero.`,
        'Attenzione',
      );
      return;
    }

    updateControlliConformita(limiti, {
      temperaturaMinima: tempMin,
      temperaturaMassima: tempMax,
      temperaturaConsigliata: tempCons,
      valoreTPMMinimo: TPMMin,
      valoreTPMMassimo: TPMMax,
    });
  };

  const passLimitiPersonalizzato = (limiti, min, max, std, tipo) => {
    if (min == null || min === '') {
      reportError('Il valore minimo non è un numero.', 'Attenzione');
      return;
    }
    if (max == null || max === '') {
      reportError('Il valore massimo non è un numero.', 'Attenzione');
      return;
    }
    if (std == null || std === '') {
      reportError('Il valore standard non è un numero.', 'Attenzione');
      return;
    }

    const prefix = tipo === 'INTERO' ? 'valoreIntero' : 'valoreDecimale';

    updateControlliConformita(limiti, {
      [`${prefix}Minimo`]: min,
      [`${prefix}Massimo`]: max,
      [`${prefix}Consigliato`]: std,
    });
    setIsLimitiModalOpen(false);
  };

  const openAssociazioneModal = (tipologia, controllo, index) => {
    if (tipologia === null || tipologia === undefined || tipologia === '0') {
      // per sicurezza, gestisco anche eventuali vecchi "0"
      setAssociazioneMode('Reparti');
    } else {
      setAssociazioneMode('Attrezzature');
    }

    setIsAssociazioneModalOpen(true);
    setControlloSelezionato(controllo);
    setIndexToUpdate(index);
  };

  const closeAssociazioneModal = () => setIsAssociazioneModalOpen(false);

  const addAttrezzatureOrRepartiToControllo = (list, mode) => {
    if (mode === 'Reparto') {
      setProcedura((prev) => {
        let newReparti = list
          .filter((reparto) => reparto.checked || reparto.repartoDefault)
          .map((reparto) => reparto.idReparto);

        // Se l'utente ha deselezionato tutti, ma esiste un reparto default, usiamo quello
        if (newReparti.length === 0) {
          newReparti = reparti
            .filter((reparto) => reparto.repartoDefault)
            .map((reparto) => reparto.id);
        }

        const updatedControlli = prev.controlliConformita.map((controllo, i) =>
          i === indexToUpdate
            ? {
                ...controllo,
                reparti: [...new Set(newReparti)],
                attrezzature: [],
              }
            : controllo,
        );

        return { ...prev, controlliConformita: updatedControlli };
      });
    } else if (mode === 'Attrezzatura') {
      setProcedura((prev) => {
        const newAttrezzature = list
          .filter((attrezzatura) => attrezzatura.checked)
          .map((attrezzatura) => attrezzatura.id);

        const updatedControlli = prev.controlliConformita.map(
          (attrezzatura, i) =>
            i === indexToUpdate
              ? {
                  ...attrezzatura,
                  attrezzature: newAttrezzature,
                }
              : attrezzatura,
        );

        return { ...prev, controlliConformita: updatedControlli };
      });
    }
    setIsAssociazioneModalOpen(false);
  };

  const getAttrezzatureName = (equipment) =>
    equipment
      .map(
        (attrezzaturaId) =>
          attrezzature.find((item) => item.id === attrezzaturaId)?.nome,
      )
      .filter(Boolean); // Rimuove eventuali elementi `undefined`;

  const openAttrezzaturaModal = (attrezzature) => {
    const attrezzatureToPass = getAttrezzatureName(attrezzature);
    setIsAttrezzatureModalOpen(true);
    setAttrezzatureToRead(attrezzatureToPass);
  };

  const closeAttrezzaturaModal = () => {
    setIsAttrezzatureModalOpen(false);
    setAttrezzatureToRead(null);
  };

  const validateAndBuildControlsForSave = () => {
    const controlliConformita = [];

    for (const item of procedura.controlliConformita ?? []) {
      const errorMessage = validateControllo(item);

      if (errorMessage) {
        return { error: errorMessage };
      }

      if (item.periodica && (item.cadenze ?? []).length === 0) {
        controlliConformita.push({
          ...item,
          cadenze: [
            {
              orario: '08:00:00',
              giornoSettimana: item.cadenza === 'SETTIMANALE' ? 'MONDAY' : null,
              giornoMese:
                item.cadenza === 'MENSILE'
                  ? 1
                  : item.cadenza === 'ANNUALE'
                    ? 1
                    : null,
              mese: item.cadenza === 'ANNUALE' ? 'JANUARY' : null,
              schedaId: null,
              controlloConformitaId: item.id,
              id: null,
            },
          ],
        });
        continue;
      }

      controlliConformita.push(item);
    }

    return { controlliConformita };
  };

  const hasEquipmentControlsWithoutAssociatedEquipment = (controlli) =>
    controlli.some((controllo) => {
      const tipologiaId = normalizeTipologiaStrumentazioneId(
        controllo.tipologiaStrumentazioneId,
      );

      return (
        tipologiaId !== null && (controllo.attrezzature ?? []).length === 0
      );
    });

  const saveControlliConformita = async ({
    skipEquipmentCheck = false,
  } = {}) => {
    const preparedControls = validateAndBuildControlsForSave();

    if (preparedControls.error) {
      reportError(preparedControls.error, 'Attenzione');
      return;
    }

    const { controlliConformita } = preparedControls;

    if (
      !skipEquipmentCheck &&
      hasEquipmentControlsWithoutAssociatedEquipment(controlliConformita)
    ) {
      setShowControlWithoutEquipmentDialog(true);
      return;
    }

    setLoading(true);

    const controlliDaSalvare = prepareControlsForSave(controlliConformita);

    try {
      await updateGestioneOperativaProceduraById(
        aggiornamentiGestioneOperativaId,
        proceduraId,
        {
          ...procedura,
          controlliConformita: controlliDaSalvare,
        },
      );

      const responseUpdated = await getGestioneOperativaProceduraById(
        aggiornamentiGestioneOperativaId,
        proceduraId,
      );
      setProcedura(responseUpdated.procedureHaccp[0]);
      setIsControlloSemplificato(
        responseUpdated.controlliSemplificati ?? false,
      );
      populateTable(responseUpdated.procedureHaccp[0]);

      handleOpenSnackbar('Controllo modificato con successo!');
      setEdit(false);
    } catch (error) {
      reportApiError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleControlloSave = async () => {
    await saveControlliConformita();
  };

  const handleGoBack = () => {
    if (edit) {
      const confirm = window.confirm(UNSAVED_CHANGES_LEAVE_MESSAGE);
      if (!confirm) return;
    }
    history.replace(`/amministrazione/esercizi_commerciali/${esercizioId}`, {
      forceTab: 1,
    });
  };

  const handleSaveControlloWithoutEquipment = async () => {
    setShowControlWithoutEquipmentDialog(false);
    await saveControlliConformita({ skipEquipmentCheck: true });
  };

  const handleCancelSaveControlloWithoutEquipment = () => {
    setShowControlWithoutEquipmentDialog(false);
  };

  return (
    <div className={classes.mainContainer}>
      {loading ? (
        <SpinnerComponent size={32} />
      ) : (
        <>
          <Container>
            <OneLineTextInputComponent
              label={'Titolo:'}
              fieldname={'titolo'}
              fieldvalue={procedura.titolo}
              onChangeEvent={handleChangeProceduraField}
            />
            <OneLineTextInputComponent
              label={'Versione:'}
              fieldname={'numVersione'}
              fieldvalue={procedura.numVersione}
              onChangeEvent={handleChangeProceduraField}
            />
            <OneLineTextInputComponent
              label={'Data versione:'}
              fieldname={'dataVersione'}
              fieldvalue={procedura.dataVersione}
              onChangeEvent={handleChangeProceduraField}
              type="date"
            />
            <MultilineTextInputComponent
              label={'Descrizione procedura'}
              fieldname={'descrizione'}
              fieldvalue={procedura.descrizione}
              onChangeEvent={handleChangeProceduraField}
            />
            <div className={classes.uploadWrapper}>
              <div className={classes.uploadContainer}>
                <FileUploader
                  uploadDisabled={imageUploadDisabled}
                  loading={uploadingImage}
                  file={newImageFile}
                  onFileSelect={handleImageFileSelection}
                  onUpload={() => uploadImage(newImageFile)}
                  accept="image/png"
                />
                <ImageList
                  immagini={procedura?.immagini || []}
                  loading={uploadingImage}
                  onRemoveAttachment={deleteImageAttachment}
                  onChangeField={changeImageField}
                  urlPath="/api/paragrafi/procedurehaccp/immagini/"
                />
              </div>
              <div className={classes.uploadContainer}>
                <FileUploader
                  uploadDisabled={pdfUploadDisabled}
                  loading={uploadingImage}
                  file={newPdfFile}
                  onFileSelect={handlePdfFileSelection}
                  onUpload={uploadPdf}
                  accept="application/pdf"
                />
                <PdfList
                  files={procedura?.files || []}
                  onRemoveAttachment={deletePdfAttachment}
                  onViewPdf={handlePdfView}
                  loading={uploadingImage}
                />
              </div>
            </div>
          </Container>
          <ControlliConformitaTable
            addControlloToTable={addControlloToTable}
            categorieControlli={categorieControlli}
            deleteRow={deleteRow}
            handleCadenzaChange={handleCadenzaChange}
            handleCategoriaControlloChange={handleCategoriaControlloChange}
            handleCheckboxChange={handleCheckboxChange}
            handleDeleteCategory={handleDeleteCategory}
            handleElementoOsservatoChange={handleElementoOsservatoChange}
            handleLimitiChange={handleLimitiChange}
            handleTipologiaElementoChange={handleTipologiaElementoChange}
            openAssociazioneModal={openAssociazioneModal}
            openAttrezzaturaModal={openAttrezzaturaModal}
            openLimitiModal={openLimitiModal}
            openNuovaCategoriaModal={openNuovaCategoriaModal}
            openOrarioModal={openOrarioModal}
            openReminderModal={openReminderModal}
            procedura={procedura}
            tipologieStrumentazioni={tipologieStrumentazioni}
            loading={loading}
          />
          <div className={classes.buttonWrapper}>
            <ActionButton
              secondaryButton
              label="Indietro"
              onClick={handleGoBack}
              disabled={loading}
            />
            <ActionButton
              disabled={loading}
              grayVersion={false}
              onClick={handleControlloSave}
              label="Salva"
            />
          </div>
          {snackbar.open && (
            <CustomSnackbar
              open={snackbar.open}
              onClose={handleCloseSnackbar}
              message={snackbar.message}
            />
          )}
          {/* Dialog for informing user there is at least one equipment control without associated equipment */}
          <TwoActionsAlertDialog
            visible={showControlWithoutEquipmentDialog}
            title={'Attenzione'}
            message={
              'Almeno un controllo su strumentazione non ha attrezzature associate. Vuoi procedere comunque?'
            }
            onIndietroClicked={handleCancelSaveControlloWithoutEquipment}
            onOkClicked={handleSaveControlloWithoutEquipment}
            okLabel="Procedi"
            indietroLabel="Annulla"
          />
          {twoActionsAlertDialog.open && (
            <TwoActionsAlertDialog
              visible={twoActionsAlertDialog.open}
              title={twoActionsAlertDialog.title}
              message={twoActionsAlertDialog.message}
              onIndietroClicked={handleCloseTwoActionsAlertDialog}
              onOkClicked={handleConfirmDeleteCategory}
            />
          )}
          {isOrarioModalOpen && (
            <ModalSelezioneOrario
              open={isOrarioModalOpen}
              onClose={closeOrarioModal}
              cadenza={cadenzaPassata}
              cadenze={controlloSelezionato.cadenze}
              mode={'Normal'}
              setCadenzeToControllo={setCadenzeToControllo}
              controlloConformita={controlloSelezionato}
            />
          )}
          {isLimitiModalOpen && (
            <ModalSelezioneLimiti
              open={isLimitiModalOpen}
              onClose={closeLimitiModal}
              reparti={reparti}
              passLimiti={passLimiti}
              passLimitiTemperatura={passLimitiTemperatura}
              passLimitiTPM={passLimitiTPM}
              passLimitiOlioFriggitrice={passLimitiOlioFriggitrice}
              passLimitiPersonalizzato={passLimitiPersonalizzato}
              mode={limitiMode}
              controlloConformita={controlloSelezionato}
              controlliSemplificati={isControlloSemplificato}
              categorieControlli={categorieControlli}
            />
          )}
          {isAssociazioneModalOpen && (
            <ModalSelezioneAssociazione
              open={isAssociazioneModalOpen}
              onClose={closeAssociazioneModal}
              mode={associazioneMode}
              reparti={reparti}
              attrezzature={attrezzature}
              controlloSelezionato={controlloSelezionato}
              saveValues={addAttrezzatureOrRepartiToControllo}
            />
          )}
          {isAttrezzatureModalOpen && (
            <ModalListaAttrezzatura
              open={isAttrezzatureModalOpen}
              onClose={closeAttrezzaturaModal}
              attrezzatureToRead={attrezzatureToRead}
            />
          )}
          {isNuovaCategoriaModalOpen && (
            <NuovaCategoriaControlloModal
              open={isNuovaCategoriaModalOpen}
              onClose={() => setIsNuovaCategoriaModalOpen(false)}
              onCreate={handleCreateCategory}
            />
          )}
          {isReminderModalOpen && (
            <ReminderModal
              open={isReminderModalOpen}
              onClose={closeReminderModal}
              onSave={setReminderOnControllo}
              onRemove={() => setReminderOnControllo(null, null)}
              reminderStyle={selectedReminder?.reminderStyle ?? null}
              reminderMessage={selectedReminder?.reminderMessage ?? ''}
            />
          )}
        </>
      )}
    </div>
  );
};

DettaglioProceduraEsercizio.propTypes = {
  esercizioId: PropTypes.string.isRequired,
  proceduraId: PropTypes.string.isRequired,
};

export default DettaglioProceduraEsercizio;
